import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { catchError } from '../../helpers/catch-error'
import { CSVLink } from "react-csv";

const Turnaround = () => {
    const params = useParams();
    const navigate = useNavigate();
    let d = new Date();
    const formatted_today = (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getDate().toString().padStart(2, "0") + '/' + d.getFullYear();
    d.setDate(d.getDate() - 30);
    const formatted_thirty_days_ago = (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getDate().toString().padStart(2, "0") + '/' + d.getFullYear();
    const [woSearch, setWoSearch] = useState({
        start_date: formatted_thirty_days_ago,
        end_date: formatted_today

    });
    const [workOrders, setWorkOrders] = React.useState(null);
    const [isLoading, setIsLoading] = useState(false);



    const [csvData, setCsvData] = React.useState(null);
    const [csvHeader, setCsvHeader] = React.useState([
        { label: "DATE RANGE", key: "date_range" },
        { label: "TOTAL NEW CASES", key: "count_cases" },
        { label: "COMPLETED CASE 1 - 5 DAYS", key: "percent_in_5" },
        { label: "COMPLETED CASE 6 - 10 DAYS", key: "percent_in_10" },
        { label: "COMPLETED CASE 11 - 15 DAYS", key: "percent_in_15" },
        { label: "COMPLETED CASES AFTER", key: "percent_in_15_plus" },
    ]);



    useEffect(() => {

        searchWorkOrders();


    }, []);




    const searchWorkOrders = () => {

        setIsLoading(true);
        var search_elements = {}

        search_elements.client_company_name = woSearch?.client_company_name;
        search_elements.start_date = woSearch?.start_date ? woSearch?.start_date : formatted_thirty_days_ago;
        search_elements.end_date = woSearch?.end_date ? woSearch?.end_date : formatted_today;
        search_elements.facility_name = woSearch?.facility_name;
        search_elements.case_manager_first_name = woSearch?.case_manager_first_name;

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-report-turnaround", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                const date_range = (woSearch?.start_date ? woSearch?.start_date : formatted_thirty_days_ago) + " To " + (woSearch?.end_date ? woSearch?.end_date : formatted_today);
                const count_cases = response?.data?.work_orders?.length;
                let total_completion_days = 0;
                let percent_in_5 = 0;
                let percent_in_10 = 0;
                let percent_in_15 = 0;
                let percent_in_15_plus = 0;

                response?.data?.work_orders?.forEach(e => {
                    const turnaround_in_days = Math.ceil(e.turnaround / 24);
                    total_completion_days += turnaround_in_days;
                    if (turnaround_in_days <= 5) {
                        percent_in_5++;
                    }
                    else if (turnaround_in_days <= 10) {
                        percent_in_10++;
                    }
                    else if (turnaround_in_days <= 15){
                        percent_in_15++;
                    }
                    else {
                        percent_in_15_plus++;
                    }

                });
                total_completion_days = total_completion_days;
                const average_turnaround = (total_completion_days / count_cases).toFixed(2);
                setWorkOrders([{
                    date_range: date_range,
                    count_cases: count_cases,
                    average_turnaround: average_turnaround,
                    total_completion_days: total_completion_days,
                    percent_in_5: percent_in_5,
                    percent_in_10: percent_in_10,
                    percent_in_15: percent_in_15,
                    percent_in_15_plus: percent_in_15_plus

                }]);
                setCsvData([{
                    date_range: date_range,
                    count_cases: count_cases,
                    total_completion_days: total_completion_days,
                    average_turnaround: average_turnaround,
                    percent_in_5: percent_in_5,
                    percent_in_10: percent_in_10,
                    percent_in_15: percent_in_15,
                    percent_in_15_plus: percent_in_15_plus
                }])

            }
            else {

                setWorkOrders(null);

            }
            setIsLoading(false);


        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)

        });


    }


    return (
        <>

            <div className="row pb-2 mt-4">
                <div className="col-md-12 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">WORK ORDERS - TURNAROUND TIME</h3>
                </div>


            </div>

            <div className="card card-form card-primary mt-4 pb-2">
                <div className="card-body">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row px-3 gx-3">


                            <div className="col-xl-2 col-lg-2 col-sm-2 my-1">
                                <label >START DATE</label>

                                <DatePicker name="start_date" id="start_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsStart
                                    isClearable={true}
                                    selected={woSearch?.start_date}
                                    onChange={(e) => {
                                        {
                                            var dt = new Date(e);

                                            const year = dt.getFullYear();
                                            const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                            const day = dt.getDate().toString().padStart(2, "0");

                                            const formatted_date = month + '/' + day + '/' + year

                                            setWoSearch({ ...woSearch, start_date: formatted_date })

                                        }
                                    }
                                    }
                                />
                            </div>
                            <div className="col-xl-2 col-lg-2 col-sm-2 my-1">
                                <label >END DATE</label>

                                <DatePicker name="end_date" id="end_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsEnd
                                    isClearable={true}
                                    selected={woSearch?.end_date}
                                    onChange={(e) => {
                                        {
                                            var dt = new Date(e);

                                            const year = dt.getFullYear();
                                            const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                            const day = dt.getDate().toString().padStart(2, "0");

                                            const formatted_date = month + '/' + day + '/' + year

                                            setWoSearch({ ...woSearch, end_date: formatted_date })

                                        }
                                    }
                                    }
                                />
                            </div>
                            <div className="col-xl-8 col-lg-8 col-sm-8 my-1">
                                <label>&nbsp;</label><br />
                                <button onClick={() => searchWorkOrders()} className="btn btn-success mx-1" type="button" disabled={isLoading ? true : false} >{isLoading ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SEARCH"} </button>
                                {csvData && <CSVLink data={csvData} headers={csvHeader} className="btn btn-warning mx-1" >Download</CSVLink>}

                                <button onClick={() => { setWoSearch(null) }} className="btn btn-danger mx-1" type="button">CLEAR SEARCH </button>

                            </div>



                        </div>


                    </form >

                </div >
            </div >
            {workOrders &&

  
                <div class="card border-4 border-dark rounded-1 card-success my-4">
                    <div class="card-body p-0">
                        <table class="table table-striped table-sm table-immediate">
                            <thead>
                                <tr>
                                    <th>DATE RANGE</th>
                                    <th>TOTAL NEW<br />CASES</th>
                                    <th>COMPLETED CASE<br /> 1 -5 DAYS</th>
                                    <th>COMPLETED CASE<br /> 6 - 10 DAYS</th>
                                    <th>COMPLETED CASE <br /> 11 - 15 DAYS</th>
                                    <th>COMPLETED CASES AFTER</th>
                                </tr>
                            </thead>
                            <tbody>
                                {workOrders?.map(w => {
                                    return (
                                        <tr>
                                            <td>{w.date_range}</td>
                                            <td>{w.count_cases}</td>
                                            <td>{w.percent_in_5}</td>
                                            <td>{w.percent_in_10}</td>
                                            <td>{w.percent_in_15}</td>
                                             <td>{w.percent_in_15_plus}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            }









        </>


    );
};

export default Turnaround;